import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { ROUTE_PATH } from "../constants/route-path";
import { AuthenticationService } from "../services/authentication.service";

/**
 * Same redirection as DefaultRedirectGuard, but keeping the WebView inside the mobile layout:
 * /webview/map is replaced by /webview/map/{first map of the office}, and /webview/call by
 * /webview/call/{first map of the office}.
 */
@Injectable({ providedIn: 'root' })
export class MobileDefaultRedirectGuard implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const office = this.authenticationService.getOfficeSelected();
    if (!office || !office.listmapid || office.listmapid.length === 0) {
      this.router.navigate([ROUTE_PATH.NO_MAP]);
      return false;
    }
    const mapId = office.listmapid.sort((a, b) => (a || "").localeCompare(b || ""))[0];
    // The map stays under the path it was opened by (map or call)
    const screen = route.routeConfig?.path ?? ROUTE_PATH.MAP;
    this.router.navigate([ROUTE_PATH.WEB_VIEW, screen, mapId]);
    return false;
  }
}
